module.exports = __webpack_public_path__ + "img/law3-m@2.40ad9d40.jpg";